import IProduto from '../entities/IProduto'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IFindAllProdutos {
  execute(): Promise<IProduto[]>
}

export default class IFindAllProdutosImpl implements IFindAllProdutos {
  constructor(private readonly loteRepository: ILoteRepository) {}

  public async execute(): Promise<IProduto[]> {
    const response = await this.loteRepository.findAllProdutos()

    return response
  }
}
